// A DimensionType part is held as a positive whole number of millimetres and nothing else — the backend
// stores only that (DimensionValues.IsStorableMillimetres) and clears the part for anything it cannot
// store. An empty part answers true because clearing is a legitimate request, not a rejected one.
export const isStorableDimensionPartValue = (value: string | number | null | undefined): boolean => {
  if (value === null || value === undefined) return true;

  // The Width/Height fields are fed their state through an `as unknown as FormFieldState<number>` cast
  // (attribute-renderer.tsx), so a part the user has touched holds a NUMBER however the type reads.
  const raw = value.toString().trim();
  if (raw === "") return true;

  return /^\d+$/.test(raw) && Number(raw) > 0;
};

// Separates "the part was cleared" from "the part holds zero". Both read as falsy, but only the first may
// blank the input: FormInteger formats every non-null value through numeral, and numeral("") renders as
// "0" — a zero the user never typed. Returning null for the empty case is what makes the field read back
// empty, while a typed 0 stays on screen to be corrected.
export const normalizeDimensionPartValue = (value: string | number | null | undefined): string | null =>
  value === null || value === undefined || value.toString() === "" ? null : (value as string);
